module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/matching_invite_mobile@2x-637c5e19ca4a794c074f399d7ef3af60.jpg";